import routesPath from '@/utils/routesPath'
import Cookies from 'js-cookie'
import { Navigate, Outlet } from 'react-router-dom'

const { LOGIN } = routesPath
// const dispatch = useAppDispatch()

const IsAuthenticated = () => {
  const accessToken = Cookies.get('token')

  // const sessionToken = sessionStorage.getItem('token')

  // if (!sessionToken) {
  //   // if window is closed and user visit page again clear cookies and log user out
  //   Cookies.remove('token')
  //   return <Navigate to={LOGIN} />
  // }
  if (!accessToken) {
    // not logged in so redirect to login page with the return url
    return <Navigate to={LOGIN} />
  }

  return <Outlet />
}

export default IsAuthenticated
